// Display-only. Checkout pricing is re-looked-up server-side (functions/_lib/pricing.js) —
// this file must never be the source of truth for what a member is charged.
export const MEMBERSHIP_TIERS = [
  {
    key: 'explorer',
    name: 'Annual Lite',
    tagline: 'For the occasional escape',
    priceCents: 12990,
    tripsPerYear: 2,
    esimGbPerTrip: 10,
    loungeVisitsPerTrip: 1,
    travelKitsPerYear: 1,
    features: [
      'Up to 2 international trips a year',
      '1 lounge visit per trip',
      '10GB eSIM data per trip',
      'Up to 1 Faye travel kit a year',
      'Travel Care exclusive offers, unlocked year-round',
    ],
    valueCents: 20500,
  },
  {
    key: 'voyager',
    name: 'Annual',
    tagline: "For travelers who don't stop at one trip",
    priceCents: 19990,
    tripsPerYear: 4,
    esimGbPerTrip: 10,
    loungeVisitsPerTrip: 1,
    travelKitsPerYear: 2,
    features: [
      'Up to 4 international trips a year',
      '1 lounge visit per trip',
      '10GB eSIM data per trip',
      'Up to 2 Faye travel kits a year',
      'Travel Care exclusive offers, unlocked year-round',
    ],
    valueCents: 36500,
    popular: true,
  },
  {
    key: 'globetrotter',
    name: 'Annual Max',
    tagline: 'For the ones always on the move',
    priceCents: 32990,
    tripsPerYear: 6,
    esimGbPerTrip: 10,
    loungeVisitsPerTrip: 1,
    travelKitsPerYear: 6,
    features: [
      'Up to 6 international trips a year',
      '1 lounge visit per trip',
      '10GB eSIM data per trip',
      'Up to 6 Faye travel kits a year',
      'Priority support',
      'Travel Care exclusive offers, unlocked year-round',
    ],
    valueCents: 61500,
  },
];

export const getMembershipTier = (key) => MEMBERSHIP_TIERS.find((t) => t.key === key);

export const formatUsd = (cents) => `$${(cents / 100).toFixed(2)}`;
